<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="addKeyValues">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="$t('services')" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { htmlToText, convertToPascalCase } from "@/helpers/utils.js";

export default {
  components: { CTableWrapper, SearchBar },
  data () {
    return {
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'title', label: i18n.t('title'), _classes: 'font-weight-bold', sortable: true },
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'remove', label: i18n.t('remove') }
      ],
      sorterValue: { column: 'id', asc: true },
      loading: false
    }
  },
  computed: {
    ...mapState('serviceValue', ['getServiceValueOutput']),
    ...mapState('serviceValue', ['deleteServiceValueOutput']),
    keyValuesInfo: function() {
      return this.getServiceValueOutput ? this.getServiceValueOutput : null;
    },
    items: function() {
      var result = this.keyValuesInfo && this.keyValuesInfo.data ? this.keyValuesInfo.data : [];

      if (result.length) {
        result.forEach(item => {
          // Check if item.value is defined before calling htmlToText
          item.readableValue = item.value ? htmlToText(item.value) : '';
        });
      }

      return result;
    },
    pages: function()
    {
      return this.keyValuesInfo ? this.keyValuesInfo.totalPages : 1;
    }
  },
  mounted: function()
  {
    console.log("ServiceValueList mounted");
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('serviceValue', ['getServiceValue']),
    ...mapActions('serviceValue', ['deteleServiceValueById']),
    rowClicked(item, index) {
        // Pass the key as a query parameter
        this.$router.push({ name: "ServiceValueEdit", query: { id: item.id } });
    },
    actionClicked(item, action) {
        switch (action.key) {
            case 'view':
                // Pass the key as a query parameter
                this.$router.push({ name: "ServiceValueEdit", query: { id: item.id } });
                break;
            case 'remove':
                if (confirm(this.$i18n.tc('confirmRemove', item.key, { name: item.key }))) {
                    this.deteleServiceValueById(item.id);
                }
                break;
            default:
                throw "The provided action is not supported!";
        }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));

      // List specific parameters
      if(this.$route.params.type)
      {
        input.type = this.$route.params.type;
      }
      
      this.getServiceValue(input); 
    },
    addKeyValues () 
    {
      router.push({ name: 'ServiceValueAdd', params: { type: this.$route.params.type }});
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }    
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deleteServiceValueOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      }
    },
    getServiceValueOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 